import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=440cdab6&scoped=true"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=440cdab6&prod&lang=scss"
import style1 from "./BankForm.vue?vue&type=style&index=1&id=440cdab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440cdab6",
  null
  
)

export default component.exports